function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M17.113 8.58569C12.9921 8.58569 10.3029 9.78804 8.01351 12.5924V9.50146H0V47.619C0 47.619 0.162684 47.6955 0.545152 47.7773C1.13879 47.9045 4.06709 48.58 6.25631 46.7086C8.15034 45.0882 8.5856 43.2125 8.5856 41.0534V35.5438C10.875 38.0045 13.5081 39.0355 17.1712 39.0355C25.0694 39.0355 31.1361 32.6251 31.1361 24.0967C31.1361 14.9971 25.2978 8.58677 17.113 8.58677V8.58569ZM15.5519 31.8613C11.1454 31.8613 7.62135 28.2111 7.62135 23.7422C7.62135 19.2732 11.7466 15.8741 15.5519 15.8741C20.0209 15.8741 23.4825 19.3368 23.4825 23.8047C23.4825 28.2726 20.0209 31.8613 15.5519 31.8613V31.8613Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M42.5294 23.2691C42.5294 26.5691 42.8946 30.5737 46.1483 34.9533C46.2118 35.0384 46.3896 35.2528 46.3896 35.2528C45.0741 37.5109 43.4171 39.03 41.2462 39.03C39.5332 39.03 37.8611 38.124 36.4681 36.5445C34.9791 34.8563 34.2681 32.652 34.2681 30.3572V0H42.5315L42.5283 23.2691H42.5294Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M83.2283 38.1208H73.2884L82.9363 23.8186L73.2884 9.50464H83.2283L92.8751 23.8186L83.2283 38.1208Z",
  fill: "#EBAF00"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M95.5265 22.1972L104.15 9.50464H94.1712L90.5361 14.7935L95.5265 22.1972Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M90.5361 32.8965C90.5383 32.903 92.2276 35.2527 92.2276 35.2527C93.8587 37.8104 95.951 39.0257 98.4451 39.0354C101.032 38.9891 102.874 36.6964 103.55 35.8927C103.55 35.8916 102.273 34.7679 100.691 32.89C98.5378 30.3324 95.6364 25.6856 95.5265 25.4863L90.5372 32.8976L90.5361 32.8965Z",
  fill: "white"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M65.8599 29.8906C64.1975 31.4237 63.0641 32.3115 60.7014 32.3115C56.5148 32.3115 54.1682 29.3897 53.8246 26.1274H75.8687C76.0077 25.6813 76.0982 25.1265 76.0982 24.2096C76.0982 15.2814 69.5726 8.58447 60.988 8.58447C52.4035 8.58447 46.1073 15.3956 46.1073 23.9231C46.1073 32.4505 52.8032 39.0332 61.1604 39.0332C66.9955 39.0332 72.0333 35.6945 74.8032 29.8896H65.861L65.8599 29.8906ZM61.0419 15.345C64.692 15.345 67.4232 17.7529 68.0524 20.8999H54.095C54.8502 17.5644 57.3918 15.345 61.043 15.345H61.0419Z",
  fill: "white"
});

var SvgPlex = function SvgPlex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    className: "dy73tx0 dy73tx1 dy73tx3 det6jp5o",
    fill: "currentColor",
    height: 48,
    viewBox: "0 0 105 48",
    width: 105,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "plex.svg";
export { ForwardRef as ReactComponent };